var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users"},_vm._l((_vm.users),function(user){return _c('div',{key:user._id,staticClass:"content"},[_c('h2',[_vm._v(_vm._s(user.name))]),_c('pre',[_vm._v(_vm._s(user))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }